<!--
 * @Author: your name
 * @Date: 2022-05-31 09
-->
<template>
  <div class="test-drive">
    <div class="test-drive-main">
      <div class="test-drive-from">
        <div class="from-box">
          <el-form ref="form" :rules="rules" :model="form" label-width="80px">
            <!-- 标题 -->
            <el-form-item class="title">
              <label class="text-1">预约试驾</label>
            </el-form-item>
            <!-- 选择车型 -->
            <el-form-item prop="car_id">
              <el-select v-model="form.car_id" placeholder="选择车辆型号" class="select-type">
                <el-option v-for="(item,idx) in modelsList" :key="idx" :label="item.pro_name" :value="item.pro_name"></el-option>
              </el-select>
            </el-form-item>
            <!-- 姓名 -->
            <el-form-item prop="true_name">
              <el-input v-model="form.true_name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <!-- 手机号 -->
            <el-form-item prop="mobile">
              <el-input v-model="form.mobile" placeholder="请输入您的手机号"></el-input>
            </el-form-item>
            <!-- 选择经销商 -->
            <p class="title">选择门店</p>
            <div class="region-box">
              <!-- 省/市 -->
              <el-form-item class="slect-box" prop="province_id">
                <el-cascader
                  ref='provinceCascader'
                  v-model="form.province_id"
                  :options="provinceList"
                  :props="props"
                  :key="cascaderKey"
                  placeholder='请选择省/市'
                  @change="changeVal"
                  popper-class="select-city">
                </el-cascader>
              </el-form-item>
              <!-- 区 -->
              <el-form-item class="slect-box" prop="city_id">
                <el-select v-model="form.region_id" @change="regionChange" :disabled="isDisabled" class="select-province" placeholder="请选择区">
                  <el-option v-for="(item,idx) in regionList" :key="idx" :label="item.area_name" :value="item.area_name"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- 门店 -->
            <el-form-item prop="chain_id">
              <el-select v-model="form.chain_id" @change="chainChange" class="select-dealer" :disabled="isChainIdDisabled" :placeholder="'请选择门店'">
                <el-option v-for="(item,idx) in chainIdList" :key="idx" :label="item.storeName" :value="item.storeId"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="sub-btn" @mouseenter="enter" @mouseleave="leave">
            <el-button type="primary" @click="onSubmit('form')"  class="submit">
              <span class="text">即刻预约</span>
              <div class="heng-animate"  :class="{'auto-widthff':hengShow}"></div>
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getAreaListApi, SubmitTestDrivesApi, getStoresApi, modelsShowApi } from "../../../../request/api";
export default {
  data(){
    return{
      hengShow:false,
      form: {
          car_id:'', //车型
          true_name: '', //姓名
          mobile:'', //手机
          province_id: '', //省
          city_id:'', //市
          region_id:'', //区
          chain_id:'', //门店
      },
      subForm: {
        "addr": "",
        "appointment": "",
        "cx": "",
        "storeId": "",
        "storeName": "",
      },
      rules:{
        car_id:[
          { required: true, message: '请选择车型', trigger: 'blur' },
        ],
        true_name:[
          { required: true, message: '请输入姓名', trigger: 'blur' },
        ],
        mobile:[
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        province_id:[
          { required: true, message: '请选择省/市', trigger: 'blur' },
        ],
        region_id:[
          { required: false, message: '请选择区', trigger: 'blur' },
        ],
        chain_id:[
          { required: true, message: '请选择门店', trigger: 'blur' },
        ],
      },
      isDisabled:true, //省/市未选择时，区选择为不可选
      provinceList:[], //省/市选择列表
      regionList:[], //区列表
      props:{value:'area_id',label:'area_name'}, //自定义级联选择属性名
      cascaderKey:1, //定义一个key 防止切换数据源时控制台报错
      isChainIdDisabled:true, //未选择省市区，门店不可选
      chainIdList:[], //门店列表
      modelsList:[], //车型列表
      labelList:[], //省/市label值
    }
  },
  mounted(){

  },
  created(){
    this.getAreaListApi()
    this.modelsShowApi()
  },
  methods:{
    // 车型数据请求
    modelsShowApi(){
      const params = {
        m:'Mobile',
        c:'MajorProduct',
        a:'get_car',
      }
      modelsShowApi(params).then(({data})=>{
        this.modelsList = data.datas.list
      })
    },
    // 省市区数据请求
    getAreaListApi(){
      const datas = {
        m:'Mobile',
        c:'Area',
        a:'get_tree_list'
      }
      getAreaListApi(datas).then(({data})=>{
        this.provinceList = data.data
        this.provinceList.forEach((item,idx) => {
          item.children.forEach((item1,idx1) => {
            item1.childrens = item1.children
            delete item1.children
          });
        });
      })
    },
    // 省/市切换时，赋值区
    changeVal(val){
      this.form.region_id = ''
      this.form.chain_id = ''
      this.labelList = this.$refs['provinceCascader'].getCheckedNodes()[0].pathLabels
      this.isChainIdDisabled = false
      this.isDisabled = false
      ++this.cascaderKey
      this.provinceList.forEach((item,idx) => {
        if (val[0] == item.area_id) {
          item.children.forEach((item1,idx1) => {
            if (val[1] == item1.area_id) {
              this.regionList = item1.childrens
            }
          });
        }
      });
      // 根据地址查找门店
      const params = {
        condition:this.labelList[0],
        locations:'',
        isFindGrade: 1,
        city:this.labelList[1],
      }
      getStoresApi(params).then(({data})=>{
        this.chainIdList = data.result
      })
    },
    // 添加地区精确查找门店
    regionChange(val){
      this.form.chain_id = ''
      // 根据地址查找门店
      const params = {
        condition:val,
        locations:'',
        isFindGrade: 1,
        city:this.labelList[1],
      }
      getStoresApi(params).then(({data})=>{
        this.chainIdList = data.result
      })
    },
    //门店选择
    chainChange(val){
      this.chainIdList.forEach(element => {
        if (element.storeId == val) {
          this.subForm.storeId = element.storeId
          this.subForm.storeName = element.storeName
          this.subForm.linkTel = element.linkTel
          this.subForm.longitude = element.longitude
          this.subForm.latitude = element.latitude
        }
      });
    },
    // 提交
    onSubmit(formName) {
      let currentTime = new Date()
      let year = currentTime.getFullYear()
      let month = currentTime.getMonth() + 1 < 10 ? '0' + (currentTime.getMonth() + 1) : currentTime.getMonth()+ 1
      let day = currentTime.getDate() < 10 ? '0' + currentTime.getDate() : currentTime.getDate()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.form.city_id = this.form.province_id[1]
          this.form.province_id = this.form.province_id[0]

          this.subForm.cx = this.form.car_id
          this.subForm.userName = this.form.true_name
          this.subForm.userTel = this.form.mobile
          this.subForm.addr = this.labelList[0] + this.labelList[1] + this.form.region_id
          this.subForm.appointment = year + '-' +month + '-' + day
          this.subForm.channel = 'pc'
          let obj = Object.assign({},this.subForm)
          SubmitTestDrivesApi(
            JSON.stringify(obj)
          ).then((data)=>{
            this.$message.success('提交成功')
            for (const key in this.form) {
              if (Object.hasOwnProperty.call(this.form, key)) {
                this.form[key] = ''
              }
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    enter(){
      this.hengShow = true
    },
    leave(){
      this.hengShow = false
    }
  }
}
</script>
<style lang="scss">
@import "./test-drives.scss";
</style>



// WEBPACK FOOTER //
// src/views/test-drive/test-drives/test-drives.vue